import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder
import qs from 'qs'

// 添加潜在客户信息
export function addPotentialCust(data) {
    return request({
        url: serviceName + `/cust/addPotentialCust`,
        method: 'post',
        data: data
    })
}

// 分页查询潜在客户
export function listPotentialCust(data) {
    return request({
        url: serviceName + `/cust/listPotentialCust`,
        method: 'get',
        params: data
    })
}

// 认领潜在客户
export function claimPotentialCust(custId, reason) {
    return request({
        url: serviceName + `/cust/claimPotentialCust`,
        method: 'post',
        data: { custId, reason }
    })
}

// 批量导入潜在客户
export function importPotentialCustBatch(file) {
    const formData = new FormData();
    formData.append('file', file);
    return request({
        url: serviceName + `/cust/addPotentialCustBatch`,
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 绑定潜在客户
export function bindPotentialCust(data) {
    return request({
        url: serviceName + `/cust/bindPotentialCust`,
        method: 'post',
        params: data
    })
}

// 更新客户联系人
export function updateLinkman(data) {
    return request({
        url: serviceName + `/cust/update_linkman` + qs.stringify(data),
        method: 'post',
        params: data
    })
}

// 统计指定省份下每个市的客户数量
export function countByCity(provinceName) {
    return request({
        url: serviceName + `/cust/countByCity`,
        method: 'get',
        params: { provinceName }
    })
}

// 分页查询指定城市所有带经纬度的客户
export function listCustWithLocation(data) {
    return request({
        url: serviceName + `/cust/listCustWithLocation`,
        method: 'get',
        params: data
    })
}

// 更新潜在客户信息
export function updatePotentialCust(data) {
    return request({
        url: serviceName + `/cust/updatePotentialCust`,
        method: 'post',
        data: data
    })
}

// 删除潜在客户
export function deletePotentialCust(id) {
    return request({
        url: serviceName + `/cust/deletePotentialCust`,
        method: 'post',
        params: { id }
    })
}

// 销售提交解绑申请
export function unbindApply(data) {
    return request({
        url: serviceName + `/unbind/apply`,
        method: 'post',
        params: data
    })
}

// 分页查询解绑申请列表
export function listUnbindApply(data) {
    return request({
        url: serviceName + `/unbind/list`,
        method: 'get',
        params: data
    })
}

// 审批解绑申请
export function approveUnbindApply(data) {
    return request({
        url: serviceName + `/unbind/audit`,
        method: 'post',
        params: data
    })
}

// 直接释放潜在客户（无需审批）
export function releasePotentialCust(custId) {
    return request({
        url: serviceName + `/cust/releasePotentialCust`,
        method: 'post',
        params: { custId }
    })
}

// 客户名称模糊搜索
export function fuzzySearch(keyword) {
    return request({
        url: serviceName + `/cust/fuzzySearch`,
        method: 'get',
        params: { keyword }
    })
}

// 客户资源池总览 - 行业维度统计
export function getIndustryStatistics() {
    return request({
        url: serviceName + `/cust/statistics/industry`,
        method: 'get'
    })
}

// 客户资源池总览 - 销售维度统计
export function getSalesStatistics() {
    return request({
        url: serviceName + `/cust/statistics/sales`,
        method: 'get'
    })
}
